// IDs configurados da Ouvidoria atual

import { AppConfig } from "@/datasources/AppConfig";


// Endpoints disponíveis para esta ouvidoria
// IMPORTANTE: Todos os endpoints são getters/funções para serem avaliados em tempo de execução,
// garantindo que sempre usem os valores atuais de AppConfig (não os valores no momento do import).
export const OUVIDORIA_ENDPOINTS = {
  // Ouvidoria
  get obterOuvidoria() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}`; },
  get atualizarOuvidoria() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}`; },
  get arquivarOuvidoria() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}/arquivar`; },
  get restaurarOuvidoria() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}/restaurar`; },
  
  // Solicitações da Ouvidoria
  get obterSolicitacoesOuvidoria() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}/solicitacoes`; },
  get transferirSolicitacao() { return `v1/municipios/${AppConfig.municipioId}/ouvidorias/${AppConfig.ouvidoriaId}/transferir-solicitacao`; },
  
  // Agentes
  get obterAgentes() { return `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes`; },
  obterAgentePorId: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}`,
  get adicionarAgente() { return `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes`; },
  atualizarAgente: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}`,
  arquivarAgente: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/arquivar`,
  restaurarAgente: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/restaurar`,
  alterarStatusAgente: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/alterar-status`,
  atribuirGestor: (agenteId: string) => `v1/ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/atribuir-gestor`,
  
  // Solicitações (gerais)
  obterSolicitacoes: 'v1/solicitacoes',
  obterSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}`,
  atualizarSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}`,
  arquivarSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/arquivar`,
  restaurarSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/restaurar`,
  alterarStatusSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/alterar-status`,
  alterarEstadoAprovacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/alterar-estado-aprovacao`,
  apoiarSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/apoiar`,
  cancelarApoioSolicitacao: (solicitacaoId: string) => `v1/solicitacoes/${solicitacaoId}/cancelar-apoio`,
  
  // Tópicos
  obterTopicos: 'v1/topicos',
  adicionarTopico: 'v1/topicos',
  obterTopico: (topicoId: string) => `v1/topicos/${topicoId}`,
  atualizarTopico: (topicoId: string) => `v1/topicos/${topicoId}`,
  arquivarTopico: (topicoId: string) => `v1/topicos/${topicoId}/arquivar`,
  restaurarTopico: (topicoId: string) => `v1/topicos/${topicoId}/restaurar`,
  
  // Iterações de Solicitações (requer agenteId)
  adicionarIteracao: (agenteId: string, solicitacaoId: string) => 
    `v1ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/solicitacoes/${solicitacaoId}/iteracoes`,
  atualizarIteracao: (agenteId: string, solicitacaoId: string, iteracaoId: string) => 
    `v1ouvidorias/${AppConfig.ouvidoriaId}/agentes/${agenteId}/solicitacoes/${solicitacaoId}/iteracoes/${iteracaoId}`,
  
  // Municípios Implantados
  municipiosImplantados: `v1/municipios-implantados`,
  solicitarImplantacao: `v1/municipios-implantados/solicitar-implantacao`,

  // Tokens de criação de ouvidoria geral
  gerarTokenOuvidoriaGeral: 'v1/ouvidorias-gerais/tokens',
  removerTokenOuvidoriaGeral: (tokenId: string) => `v1/ouvidorias-gerais/tokens/${tokenId}`,
};

// Tipos de dados
export interface OuvidoriaData {
  id: string;
  nome: string;
  cnpj?: string;
  email?: string;
  telefone?: string;
  endereco?: string;
  arquivada?: boolean;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

export interface SolicitacaoData {
  id: string;
  upn?: string;
  status: string;
  estadoAprovacao?: string;
  topico?: {
    id: string;
    descricao: string;
  };
  dataCriacao?: string;
  totalApoiadores?: number;
  endereco?: {
    logradouro?: string;
    numero?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
  };
  anexos?: Array<{
    id: string;
    arquivo?: string;
  }>;
}

export interface TopicoData {
  id: string;
  descricao: string;
  contexto?: string;
  metodoValidacao?: string;
  status?: string;
  tipo?: string;
  arquivado?: boolean;
  etiquetas?: string[];
}

export interface AgenteData {
  id: string;
  nome: string;
  email?: string;
  cargo?: string;
  ativo?: boolean;
  gestor?: boolean;
}
export { AppConfig };

